/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataSurveyShape } from './DataSurveyShape';
import {
    DataSurveyShapeFromJSON,
    DataSurveyShapeFromJSONTyped,
    DataSurveyShapeToJSON,
    DataSurveyShapeToJSONTyped,
} from './DataSurveyShape';
import type { DataPointHistoryLocation } from './DataPointHistoryLocation';
import {
    DataPointHistoryLocationFromJSON,
    DataPointHistoryLocationFromJSONTyped,
    DataPointHistoryLocationToJSON,
    DataPointHistoryLocationToJSONTyped,
} from './DataPointHistoryLocation';

/**
 * Site serializer, displaying all non-relational site fields.
 * @export
 * @interface Site
 */
export interface Site {
    /**
     * 
     * @type {string}
     * @memberof Site
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof Site
     */
    siteName?: string;
    /**
     * Type of site inferred from satellite imagery
     * @type {string}
     * @memberof Site
     */
    siteTypeFromImagery?: string;
    /**
     * 
     * @type {Date}
     * @memberof Site
     */
    dateOfInstallation?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Site
     */
    operatorStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof Site
     */
    subpartWSegment?: string;
    /**
     * 
     * @type {string}
     * @memberof Site
     */
    operatorUniqueId?: string;
    /**
     * 
     * @type {string}
     * @memberof Site
     */
    otherOperatorIds?: string;
    /**
     * 
     * @type {number}
     * @memberof Site
     */
    owner?: number | null;
    /**
     * 
     * @type {DataPointHistoryLocation}
     * @memberof Site
     */
    location: DataPointHistoryLocation;
    /**
     * 
     * @type {DataSurveyShape}
     * @memberof Site
     */
    shape?: DataSurveyShape | null;
    /**
     * 
     * @type {Date}
     * @memberof Site
     */
    startDate?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Site
     */
    endDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Site
     */
    timeZone?: string;
    /**
     * 
     * @type {string}
     * @memberof Site
     */
    siteDataSource?: string;
    /**
     * Gets emission sum if specified.
     * @type {number}
     * @memberof Site
     */
    readonly emissionSum: number;
    /**
     * Gets emission count if specified.
     * @type {number}
     * @memberof Site
     */
    readonly emissionCount: number;
    /**
     * Gets total_emission_count.
     * @type {number}
     * @memberof Site
     */
    readonly totalEmissionCount: number;
    /**
     * 
     * @type {any}
     * @memberof Site
     */
    extraData?: any | null;
    /**
     * 
     * @type {any}
     * @memberof Site
     */
    sensorConfig?: any | null;
    /**
     * 
     * @type {string}
     * @memberof Site
     */
    responsiblePerson?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Site
     */
    readonly responsiblePersonName: string;
    /**
     * Returns the presets containing this site, limited to the ones
     * the user can access.
     * @type {Array<number>}
     * @memberof Site
     */
    readonly presetIds: Array<number>;
}

/**
 * Check if a given object implements the Site interface.
 */
export function instanceOfSite(value: object): value is Site {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('location' in value) || value['location'] === undefined) return false;
    if ((!('emissionSum' in (value as Record<string, any>)) && !('emission_sum' in (value as Record<string, any>))) || ((value as Record<string, any>)['emissionSum'] === undefined && (value as Record<string, any>)['emission_sum'] === undefined)) return false;
    if ((!('emissionCount' in (value as Record<string, any>)) && !('emission_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['emissionCount'] === undefined && (value as Record<string, any>)['emission_count'] === undefined)) return false;
    if ((!('totalEmissionCount' in (value as Record<string, any>)) && !('total_emission_count' in (value as Record<string, any>))) || ((value as Record<string, any>)['totalEmissionCount'] === undefined && (value as Record<string, any>)['total_emission_count'] === undefined)) return false;
    if ((!('responsiblePersonName' in (value as Record<string, any>)) && !('responsible_person_name' in (value as Record<string, any>))) || ((value as Record<string, any>)['responsiblePersonName'] === undefined && (value as Record<string, any>)['responsible_person_name'] === undefined)) return false;
    if ((!('presetIds' in (value as Record<string, any>)) && !('preset_ids' in (value as Record<string, any>))) || ((value as Record<string, any>)['presetIds'] === undefined && (value as Record<string, any>)['preset_ids'] === undefined)) return false;
    return true;
}

export function SiteFromJSON(json: any): Site {
    return SiteFromJSONTyped(json, false);
}

export function SiteFromJSONTyped(json: any, ignoreDiscriminator: boolean): Site {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'siteName': json['site_name'] == null ? undefined : json['site_name'],
        'siteTypeFromImagery': json['site_type_from_imagery'] == null ? undefined : json['site_type_from_imagery'],
        'dateOfInstallation': json['date_of_installation'] === undefined ? undefined : json['date_of_installation'] === null ? null : (new Date(json['date_of_installation'])),
        'operatorStatus': json['operator_status'] == null ? undefined : json['operator_status'],
        'subpartWSegment': json['subpart_w_segment'] == null ? undefined : json['subpart_w_segment'],
        'operatorUniqueId': json['operator_unique_id'] == null ? undefined : json['operator_unique_id'],
        'otherOperatorIds': json['other_operator_ids'] == null ? undefined : json['other_operator_ids'],
        'owner': json['owner'] === undefined ? undefined : json['owner'] === null ? null : json['owner'],
        'location': DataPointHistoryLocationFromJSON(json['location']),
        'shape': json['shape'] === undefined ? undefined : json['shape'] === null ? null : DataSurveyShapeFromJSON(json['shape']),
        'startDate': json['start_date'] === undefined ? undefined : json['start_date'] === null ? null : (new Date(json['start_date'])),
        'endDate': json['end_date'] === undefined ? undefined : json['end_date'] === null ? null : (new Date(json['end_date'])),
        'timeZone': json['time_zone'] == null ? undefined : json['time_zone'],
        'siteDataSource': json['site_data_source'] == null ? undefined : json['site_data_source'],
        'emissionSum': json['emission_sum'],
        'emissionCount': json['emission_count'],
        'totalEmissionCount': json['total_emission_count'],
        'extraData': json['extra_data'] === undefined ? undefined : json['extra_data'] === null ? null : json['extra_data'],
        'sensorConfig': json['sensor_config'] === undefined ? undefined : json['sensor_config'] === null ? null : json['sensor_config'],
        'responsiblePerson': json['responsible_person'] === undefined ? undefined : json['responsible_person'] === null ? null : json['responsible_person'],
        'responsiblePersonName': json['responsible_person_name'],
        'presetIds': json['preset_ids'],
    };
}

export function SiteToJSON(json: any): Site {
    return SiteToJSONTyped(json, false);
}

export function SiteToJSONTyped(value?: Omit<Site, 'id'|'emissionSum'|'emissionCount'|'totalEmissionCount'|'responsiblePersonName'|'presetIds'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'site_name': value['siteName'],
        'site_type_from_imagery': value['siteTypeFromImagery'],
        'date_of_installation': value['dateOfInstallation'] == null ? value['dateOfInstallation'] : value['dateOfInstallation'].toISOString().substring(0,10),
        'operator_status': value['operatorStatus'],
        'subpart_w_segment': value['subpartWSegment'],
        'operator_unique_id': value['operatorUniqueId'],
        'other_operator_ids': value['otherOperatorIds'],
        'owner': value['owner'],
        'location': DataPointHistoryLocationToJSON(value['location']),
        'shape': DataSurveyShapeToJSON(value['shape']),
        'start_date': value['startDate'] == null ? value['startDate'] : value['startDate'].toISOString().substring(0,10),
        'end_date': value['endDate'] == null ? value['endDate'] : value['endDate'].toISOString().substring(0,10),
        'time_zone': value['timeZone'],
        'site_data_source': value['siteDataSource'],
        'extra_data': value['extraData'],
        'sensor_config': value['sensorConfig'],
        'responsible_person': value['responsiblePerson'],
    };
}

